module.exports = __webpack_public_path__ + "static/media/img-talent-app-interview-reminding@3x.b09df116.png";